// extracted by mini-css-extract-plugin
export var compact = "_me-2";
export var phoneFrame = "_me-0";
export var phoneScreen = "_me-1";